import React, { memo } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SponsorsSection from './components/SponsorsSection';
import PrizesSection from './components/PrizesSection';
import PublicSpaceSection from './components/PublicSpaceSection';
import ScheduleSection from './components/ScheduleSection';
//import CalendarReminderSection from './components/CalendarReminderSection';
import GuidesSection from './components/GuidesSection';
import FAQSection from './components/FAQSection';
import RegistrationSection from './components/RegistrationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingElements from './components/FloatingElements';
import NotificationDisplay from './components/NotificationDisplay';
import './utils/testSheet'; // Import test to run automatically
import './App.css';

// Memoize the FloatingElements component to prevent unnecessary re-renders
const MemoizedFloatingElements = memo(FloatingElements);

function App() {
  return (
    <div className="App">
      <MemoizedFloatingElements />
      <NotificationDisplay />
      <HeroSection />
      <AboutSection />
      <SponsorsSection />
      <PrizesSection />
      <PublicSpaceSection />
      <ScheduleSection />
      <GuidesSection />
      <FAQSection />
      <RegistrationSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
